import OrganizationEventSubscriptionsIndexPage from "./OrganizationEventSubscriptionsIndexPage";
export default OrganizationEventSubscriptionsIndexPage;
